export default __webpack_public_path__ + "static/SocialButton-1edea9561de19867140914f3f1ff4563.svg";